export default class {
    urls = {};

    constructor(urls) {
        this.urls.list = urls.route_list;
        this.urls.create = urls.route_create;
        this.urls.delete = urls.route_delete;
        this.urls.get = urls.route_get;
        this.urls.update = urls.route_update;
        this.urls.client_search = urls.route_client_search;
        this.urls.organization_search = urls.route_organization_search;
        this.urls.brand_search = urls.route_brand_search;
        this.urls.region_search = urls.route_region_search;
        this.urls.city_search = urls.route_city_search;
        this.urls.device_types_search = urls.route_device_types_search;
        this.urls.locations_search = urls.route_locations_search;
        this.urls.worktimes_search = urls.route_worktimes_search;
        this.urls.devices_search = urls.route_devices_search;
        this.urls.repository_search = urls.route_repository_search;
        this.urls.device_groups_search = urls.route_device_groups_search;
        this.urls.release_versions_search = urls.route_release_versions_search;
        this.urls.groups_by_device_type = urls.route_groups_by_device_type;
        this.urls.route_operating_systems = urls.route_operating_systems;
        this.urls.versions_types = urls.route_versions_types;
    }

    async list(page = 1, limit = 0, search = '', params = {}, brand = null, device_type = null) {
        if(this.urls.list === undefined)
        {
            console.log('error: url_list_undefined');
            return false;
        }
        return await axios.get(this.urls.list, {
            params: {
                page: page,
                limit: limit,
                search: search,
                params: params,
                brand: brand,
                device_type: device_type
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });
    }

    async create(params) {
        if(this.urls.create === undefined)
        {
            console.log('error: url_create_undefined');
            return false;
        }
        return await axios.post(this.urls.create, params).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async delete(id) {
        if(this.urls.delete === undefined)
        {
            console.log('error: url_delete_undefined');
            return false;
        }
        return await axios.delete(this.urls.delete, {
            params: {
                id: id
            }
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async get(id, type_id = 1) {
        if(this.urls.get === undefined)
        {
            console.log('error: url_get_undefined');
            return false;
        }
        return await axios.get(this.urls.get, {
            params: {
                id: id,
                type: type_id
            }
        }).then(response => {
            if(response.data.status === 'ok')
            {
                return response.data.object;
            }
            return false;
        })
    }

    async update(params, id) {
        if(this.urls.update === undefined)
        {
            console.log('error: url_update_undefined');
            return false;
        }
        return await axios.post(this.urls.update, {
            params: params,
            id: id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async data_loader(url, params = {}) {
        return await axios.get(url, { params: params}).then(response => {
            if(response.data.status === 'ok')
            {
                return {
                    items: response.data.items,
                    pages: (response.data.hasOwnProperty('pages')) ? response.data.pages : 0
                };
            }
            return false;
        });
    }

    async clients(params) {
        if(this.urls.client_search === undefined)
        {
            console.log('error: route_client_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.client_search, params);
    }

    async organizations(params) {
        if(this.urls.organization_search === undefined)
        {
            console.log('error: route_organization_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.organization_search, params);
    }

    async brands(params) {
        if(this.urls.brand_search === undefined)
        {
            console.log('error: route_brand_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.brand_search, params);
    }

    async regions(params) {
        if(this.urls.region_search === undefined)
        {
            console.log('error: route_region_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.region_search, params);
    }

    async cities(params) {
        if(this.urls.city_search === undefined)
        {
            console.log('error: route_city_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.city_search, params);
    }

    async deviceTypes(params) {
        if(this.urls.device_types_search === undefined)
        {
            console.log('error: route_device_types_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.device_types_search, params);
    }

    async locations(params) {
        if(this.urls.locations_search === undefined)
        {
            console.log('error: route_locations_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.locations_search, params);
    }

    async worktimes(params) {
        if(this.urls.worktimes_search === undefined)
        {
            console.log('error: route_worktimes_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.worktimes_search, params);
    }

    async devices(params) {
        if(this.urls.devices_search === undefined)
        {
            console.log('error: route_devices_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.devices_search, params);
    }

    async repositories(params) {
        if(this.urls.repository_search === undefined)
        {
            console.log('error: route_repository_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.repository_search, params);
    }

    async deviceGroups(params) {
        if(this.urls.device_groups_search === undefined)
        {
            console.log('error: route_device_groups_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.device_groups_search, params);
    }

    async releaseVersions(params) {
        if(this.urls.release_versions_search === undefined)
        {
            console.log('error: route_release_versions_search_undefined');
            return false;
        }
        return this.data_loader(this.urls.release_versions_search, params);
    }

    async getDevicesGroupsByDeviceType(params){
        if(this.urls.groups_by_device_type === undefined)
        {
            console.log('error: groups_by_device_type_undefined');
            return false;
        }
        return this.data_loader(this.urls.groups_by_device_type, params);
    }
    async getOperatingSystems(params){
        if(this.urls.route_operating_systems === undefined)
        {
            console.log('error: route_operating_systems_undefined');
            return false;
        }
        return this.data_loader(this.urls.route_operating_systems, params);
    }
    async getVersionsTypes(params){
        if(this.urls.versions_types === undefined)
        {
            console.log('error: route_versions_types_undefined');
            return false;
        }
        return this.data_loader(this.urls.versions_types, params);
    }
}
